export default "__VITE_ASSET__1J$d5odn__"